import { getData } from "../../utils";
import { cdek, mhand } from "./cdek";
import { calculateOrderPrice } from "./deliveryOrder.js";
import { z } from "../../../libraries/zod.js";

let CAN_VALID = false
let CHOOSE_CITY = false

export let shopsData

export async function getAllCitiesWithCoordinates() {
    try {
        // Получаем данные из локального API для совместимости
        const response = await fetch('/api/shops/');
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        shopsData = await response.json();
        
        // Инициализируем DaData функционал
        initDaDataForCityMap();
        
        // Инициализируем обработчик для #new-city-modal-input
        initNewCityModalInput();

    } catch (error) {
        console.error(error);
        return [];
    }
}

// Функция инициализации DaData для cityMap
function initDaDataForCityMap() {
    const input = document.querySelector('#find-city-modal');
    if (!input) return;

    // Токен DaData
    const DADATA_TOKEN = '6d16c03eba1191a4349adef36b7f2f82685e6cb2';
    const API_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

    let suggestBox;
    let suppressSuggest = false;

    function ensureSuggestBox() {
        if (suggestBox) return suggestBox;
        suggestBox = document.createElement('div');
        suggestBox.style.position = 'absolute';
        suggestBox.style.zIndex = '1000';
        suggestBox.style.background = '#fff';
        suggestBox.style.border = '1px solid #E6E6E6';
        suggestBox.style.borderRadius = '8px';
        suggestBox.style.maxHeight = '220px';
        suggestBox.style.overflowY = 'auto';
        suggestBox.style.padding = '6px 0';
        suggestBox.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
        suggestBox.style.display = 'none';
        
        const wrapper = input.closest('.input-label') || input.parentElement;
        wrapper.style.position = 'relative';
        wrapper.appendChild(suggestBox);
        return suggestBox;
    }

    function hideSuggest() {
        if (!suggestBox) return;
        suggestBox.style.display = 'none';
        suggestBox.innerHTML = '';
    }

    function render(items) {
        const box = ensureSuggestBox();
        box.innerHTML = '';
        if (!items.length) {
            hideSuggest();
            return;
        }
        
        items.forEach(({ city, label, coordinates }) => {
            const el = document.createElement('div');
            el.textContent = label;
            el.classList.add('address-menu__info-list__item');
            el.style.padding = '8px 12px';
            el.style.cursor = 'pointer';
            el.addEventListener('mousedown', (e) => {
                e.preventDefault();
                suppressSuggest = true;
                input.value = city || label;
                input.dataset.cityValid = 'true';
                input.dataset.cityValue = city || label;
                input.dataset.coordinates = coordinates || '';
                hideSuggest();
                
                // Вызываем обработку выбора города
                handleCitySelection(city || label, coordinates);
                
                setTimeout(() => { suppressSuggest = false; }, 250);
            });
            el.addEventListener('mouseenter', () => { el.style.background = '#F5F5F5'; });
            el.addEventListener('mouseleave', () => { el.style.background = 'transparent'; });
            box.appendChild(el);
        });
        
        box.style.left = '0px';
        box.style.right = '0px';
        box.style.top = `${(input.offsetHeight || 0) + 20}px`;
        box.style.display = 'block';
        box.style.maxHeight = '15rem';
        box.style.height = 'fit-content';
    }

    async function fetchCities(q) {
        if (!DADATA_TOKEN || q.length < 2) {
            hideSuggest();
            return;
        }
        
        const payload = {
            query: q,
            count: 10,
            from_bound: { value: 'city' },
            to_bound: { value: 'city' },
            locations: [{ country: 'Россия' }]
        };
        
        let res;
        try {
            res = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${DADATA_TOKEN}`
                },
                body: JSON.stringify(payload)
            });
        } catch (_) {
            res = null;
        }
        
        if (!res || !res.ok) {
            hideSuggest();
            return;
        }
        
        let data = null;
        try {
            data = await res.json();
        } catch (_) {}
        
        const items = (data?.suggestions || []).map(s => {
            const city = s.data.city || s.data.settlement || '';
            const label = s.data.city_with_type || s.data.settlement_with_type || s.value;
            
            // Убираем "г." из названия города
            const cleanLabel = label.replace(/^г\.\s*/i, '');
            const cleanCity = city.replace(/^г\.\s*/i, '');
            
            return {
                city: cleanCity,
                label: cleanLabel,
                coordinates: s.data.geo_lat && s.data.geo_lon ? `${s.data.geo_lat},${s.data.geo_lon}` : ''
            };
        }).filter(x => x.city || x.label);
        
        render(items);
    }

    const onInput = debounce((e) => {
        if (suppressSuggest) return;
        if (!e || !e.isTrusted) return;
        
        const q = input.value.trim();
        input.dataset.cityValid = 'false';
        input.dataset.cityValue = '';
        input.dataset.coordinates = '';
        
        if (!q) {
            hideSuggest();
            return;
        }
        
        // Проверяем, есть ли точное совпадение с городом из API
        const exactMatch = shopsData?.results?.find(city => 
            city.city.toLowerCase().trim() === q.toLowerCase().trim()
        );
        
        if (exactMatch) {
            console.log('Найдено точное совпадение с городом:', exactMatch.city);
            
            // Скрываем подсказки
            hideSuggest();
            
            // Устанавливаем значение города
            input.value = exactMatch.city;
            input.dataset.cityValid = 'true';
            input.dataset.cityValue = exactMatch.city;
            
            // Вызываем обработку выбора города
            handleCitySelection(exactMatch.city, exactMatch.coordinates);
            
            return;
        }
        
        fetchCities(q);
    }, 300);

    input.addEventListener('input', (e) => onInput(e));
    input.addEventListener('blur', () => setTimeout(hideSuggest, 120));
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') hideSuggest(); });
    document.addEventListener('click', (e) => {
        if (suggestBox && !suggestBox.contains(e.target) && e.target !== input) {
            hideSuggest();
        }
    });
}

// Функция debounce для DaData
function debounce(func, timeout) {
    let timer;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(context, args);
        }, timeout);
    };
}

// Обработчик выбора города
function handleCitySelection(cityName, coordinates) {
    console.log('Обработка выбора города:', cityName, coordinates);
    
    // Сначала пытаемся найти город в локальном API
    const exactMatch = shopsData?.results?.find(city => 
        city.city.toLowerCase().trim() === cityName.toLowerCase().trim()
    );
    
    let finalCoordinates = coordinates;
    
    if (exactMatch) {
        // Используем координаты из локального API
        finalCoordinates = exactMatch.coordinates;
        console.log('Найден в локальном API:', exactMatch);
    } else if (coordinates) {
        // Используем координаты из DaData
        console.log('Используем координаты из DaData:', coordinates);
    } else {
        // Геокодируем город через Яндекс.Карты
        console.log('Геокодируем город:', cityName);
        // Здесь можно добавить геокодирование через Яндекс.Карты
    }
    
    // Заполняем поля города
    const cityInput = document.querySelector('#new-city-modal-input');
    const cityMap = document.querySelector('#city-map-modal-city');
    
    if (cityInput || cityMap) {
        cityInput.value = cityName;
        cityMap.value = cityName;
        cityInput.dispatchEvent(new Event('input'));
        cityMap.dispatchEvent(new Event('input'));
    }

    // Сброс состояния способов доставки при смене города
    if (window.resetDeliveryState) {
        try { window.resetDeliveryState(); } catch (e) {}
    }

    // Парсим координаты
    const parsedCoordinates = parseCoordinates(finalCoordinates);
    
    if (parsedCoordinates) {
        console.log('Вызываем CDEK с координатами:', parsedCoordinates);
        cdek(parsedCoordinates, { skipInitialSelect: true });
        mhand(parsedCoordinates);
    }

    const deliveryMethods = document.querySelector('.order-section__card__delivery-list');
    if (!deliveryMethods) return;

    deliveryMethods.style.display = 'grid';

    checkForDeliveryMhand(cityName);

    CHOOSE_CITY = true;
    
    // Получаем цены доставки для CDEK
    getData(`/cdek-delivery/select-city?city=${cityName}`)
        .then(res => {
            console.log('Получены цены доставки:', res);
            const price137 = document.querySelector('#price-137');
            const price136 = document.querySelector('#price-136');
            if (price137) price137.textContent = `${res[0].total_delivery_sum} руб.`;
            if (price136) price136.textContent = `${res[1].total_delivery_sum} руб.`;
        })
        .catch(error => {
            console.error('Ошибка получения цен доставки:', error);
        });
}

// Обработчик для поля #new-city-modal-input (если оно существует)
function initNewCityModalInput() {
    const newCityManualInput = document.querySelector('#new-city-modal-input');
    if (!newCityManualInput) return;

    newCityManualInput.addEventListener('input', () => {
        const typedValue = newCityManualInput.value.toLowerCase().trim();
        if (typedValue.length < 2) {
            return;
        }

        // Ищем город в локальном API
        const exact = shopsData?.results?.find(c => c.city.toLowerCase().trim() === typedValue);
        if (exact) {
            // Разблокируем поле адреса и переводим форму в состояние ожидания адреса
            const addressMenus = document.querySelectorAll('.__address_input__menu[data-list="address"]');
            addressMenus.forEach(menu => {
                const addrInput = menu.querySelector('.__address_input__input');
                if (addrInput) {
                    addrInput.classList.remove('disabled');
                    addrInput.value = '';
                    if (addrInput.form) {
                        addrInput.form.dataset.state = 'disabled';
                    }
                }
            });

            // Отмечаем, что город выбран (для отображения последующих блоков)
            CHOOSE_CITY = true;
        }
    });
}


// Глобальный сброс состояния способов доставки и активных элементов
function resetDeliveryState() {
    // Сброс выбранных радио (способов доставки)
    const radios = document.querySelectorAll('input[name="delivery_way__selector"]');
    radios.forEach(r => { r.checked = false; });

    // Скрыть блоки с картой/формой доставки
    const displays = document.querySelectorAll('[data-display]');
    displays.forEach(d => { d.dataset.state = 'disabled'; });

    // Явно скрыть контейнеры карт, даже если были открыты
    const cdekMapContainer = document.querySelector('.order-section__card__delivery-map[data-display="cdek"]');
    const mhandMapContainer = document.querySelector('.order-section__card__delivery-map[data-display="mhand"]');
    if (cdekMapContainer) cdekMapContainer.style.display = 'none';
    if (mhandMapContainer) mhandMapContainer.style.display = 'none';

    // Очистить заголовки dropdown и закрыть тела
    const dropdownHeaders = document.querySelectorAll('.item-delivery .dropdown .dropdown__header__text');
    dropdownHeaders.forEach(header => {
        header.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                <path d="M11.2111 1.65423C10.5179 1.03951 9.70243 0.57837 8.81834 0.301094C7.93425 0.0238169 7.00151 -0.0633302 6.08135 0.045374C4.46691 0.273565 2.99193 1.08509 1.93505 2.32666C0.878168 3.56823 0.312561 5.15386 0.345078 6.78402C0.355587 8.41038 0.953941 9.97807 2.02974 11.1978L5.78653 15.4937C5.9249 15.6527 6.09575 15.7801 6.28755 15.8675C6.47936 15.9548 6.68766 16 6.89841 16C7.10916 16 7.31746 15.9548 7.50927 15.8675C7.70107 15.7801 7.87192 15.6527 8.01029 15.4937L11.7671 11.1978C12.8429 9.97807 13.4412 8.41038 13.4517 6.78402V6.53132C13.4447 5.60612 13.2414 4.69295 12.8551 3.8522C12.4689 3.01145 11.9085 2.26228 11.2111 1.65423ZM12.1377 6.7756C12.1388 8.0931 11.6597 9.36584 10.79 10.3555L7.03318 14.6598C6.92368 14.7777 6.8226 14.7862 6.7131 14.6598L2.9563 10.3555C2.0866 9.36584 1.60745 8.0931 1.60857 6.7756C1.57642 5.45534 2.02925 4.16908 2.8814 3.16016C3.73356 2.15123 4.92594 1.4896 6.23297 1.30045C6.44899 1.28786 6.66555 1.28786 6.88157 1.30045C8.26986 1.30484 9.60042 1.85656 10.5845 2.83587C11.5685 3.81518 12.1266 5.14306 12.1377 6.53132V6.7756Z" fill="#414141" fill-opacity="0.56"/>
                <path d="M6.87261 3.37207C6.24787 3.37207 5.63716 3.55733 5.11771 3.90441C4.59826 4.2515 4.19339 4.74483 3.95431 5.32201C3.71524 5.8992 3.65268 6.53432 3.77456 7.14705C3.89644 7.75979 4.19728 8.32262 4.63904 8.76438C5.0808 9.20614 5.64363 9.50698 6.25637 9.62886C6.86911 9.75074 7.50422 9.68818 8.08141 9.44911C8.65859 9.21003 9.15192 8.80517 9.49901 8.28571C9.84609 7.76626 10.0314 7.15555 10.0314 6.53081C10.0314 5.69306 9.69856 4.88962 9.10618 4.29724C8.5138 3.70487 7.71036 3.37207 6.87261 3.37207ZM6.87261 8.42606C6.49777 8.42606 6.13134 8.3149 5.81967 8.10665C5.508 7.8984 5.26508 7.6024 5.12163 7.25609C4.97819 6.90978 4.94065 6.52871 5.01378 6.16107C5.08691 5.79343 5.26741 5.45573 5.53247 5.19067C5.79752 4.92562 6.13522 4.74511 6.50287 4.67198C6.87051 4.59885 7.25158 4.63639 7.59789 4.77983C7.9442 4.92328 8.2402 5.1662 8.44845 5.47787C8.6567 5.78954 8.76785 6.15597 8.76785 6.53081C8.76785 7.03346 8.56818 7.51552 8.21275 7.87095C7.85732 8.22638 7.37526 8.42606 6.87261 8.42606Z" fill="#414141" fill-opacity="0.56"/>
            </svg>
            Добавить адрес доставки`;
    });

    const dropdownBodies = document.querySelectorAll('.item-delivery .dropdown .dropdown__body');
    dropdownBodies.forEach(body => body.classList.add('none'));

    // Сброс блока адреса под картой
    const cdekAddressBlock = document.querySelector('.__cdek_map__address');
    if (cdekAddressBlock) {
        cdekAddressBlock.innerText = 'Не выбрано';
        cdekAddressBlock.dataset.city = '';
        cdekAddressBlock.dataset.id = '';
    }

    // Сброс формы заказа
    const orderForm = document.querySelector('#order-form');
    if (orderForm) {
        delete orderForm.dataset.city_name;
        delete orderForm.dataset.cdek_order;
    }

    // Очистить видимый адрес доставки
    const deliveryAddressView = document.querySelector('.delivery__address');
    if (deliveryAddressView) {
        deliveryAddressView.innerHTML = '';
    }

    // Скрыть самовывоз MHAND до пересчета
    const mhandItem = document.querySelectorAll('.item-delivery')[2];
    if (mhandItem) {
        mhandItem.style.display = 'none';
        const headerText = mhandItem.querySelector('#samo-delivery');
        if (headerText) headerText.textContent = 'Добавить адрес доставки';
    }
}

// Делаем функцию доступной глобально (для вызова из других модулей)
window.resetDeliveryState = resetDeliveryState;


function parseCoordinates(coordinatesString) {
    if (!coordinatesString) return null;
    
    const coords = coordinatesString.replace(/\s/g, '').split(',');
    
    const latitude = parseFloat(coords[0]);
    const longitude = parseFloat(coords[1]);
    
    if (isNaN(latitude) || isNaN(longitude)) {
        return null;
    }
    
    return [latitude, longitude];
}

function checkForDeliveryMhand(city) {
    const productCards = document.querySelectorAll('.product-card-order');
    let addresses = Array.from(productCards).map(card => card.dataset.address);
    let cities = Array.from(productCards).map(card => card.dataset.city);


    addresses = [...new Set(addresses)]
    cities = [...new Set(cities)]

    if (cities.length === 1 && addresses.length === 1 && city === cities[0]) {
        const itemDelivery = document.querySelectorAll('.item-delivery')[2]
        itemDelivery.style.display = 'grid'
        const headerText = itemDelivery.querySelector('#samo-delivery')
        headerText.textContent = addresses[0]
    }
}

// Валидация формы заказа через Zod
function validateOrderForm() {
    const orderForm = document.querySelector('#order-form');
    
    if (!orderForm) {
        console.error('Форма заказа не найдена');
        return;
    }
    
    // Схема валидации для формы заказа
    const orderFormSchema = z.object({
        first_name: z.string().min(1, { message: "Имя обязательно для заполнения" }),
        last_name: z.string().min(1, { message: "Фамилия обязательна для заполнения" }),
        phone: z.string().min(18, { message: "Введите корректный номер телефона" }),
        email: z.string().email({ message: "Введите корректный email адрес" }),
        // Поля для карты (опциональные)
        card_number: z.string().optional(),
        card_term: z.string().optional(),
        card_cvv: z.string().optional(),
        // Промокод (опциональный)
        promo_code: z.string().optional()
    });
    
    // Функция валидации формы
    function validateOrderFormFields() {
        
        console.log('begin validate');
        
        const formData = new FormData(orderForm);
        const body = {};
        
        const blockForm = document.querySelector('#order-form')
        // const checkBox = document.querySelector('#save-in-profile-checkbox').parentElement

        if (blockForm) {
            setTimeout(() => {
                blockForm.style.display = 'grid'
                // checkBox.style.display = 'flex'
            }, 5);
        }

        // Собираем данные из формы
        for (let [key, value] of formData.entries()) {
            body[key] = value;
        }
        
        try {
            // Валидируем данные
            const validatedData = orderFormSchema.parse(body);
            
            // Показываем блок выбора города при успешной валидации
            const cityInputBlock = document.querySelector('.modal__content_new-address__form__input-address');
            if (cityInputBlock) {
                cityInputBlock.style.display = 'grid';
            }

            CAN_VALID = true
            
            console.log(CAN_VALID);

            return true;
        } catch (error) {
            // Скрываем блок выбора города при ошибках валидации
            const cityInputBlock = document.querySelector('.modal__content_new-address__form__input-address');
            if (cityInputBlock) {
                cityInputBlock.style.display = 'none';
            }

            CAN_VALID = false
            
            return false;
        }
    }
    
    // Добавляем обработчики событий для валидации в реальном времени
    const inputs = orderForm.querySelectorAll('input');
    inputs.forEach(input => {
        input.addEventListener('input', () => {
            validateOrderFormFields();
        });
        
        input.addEventListener('blur', () => {
            validateOrderFormFields();
        });
    });
    
    // Валидируем форму при загрузке страницы
    validateOrderFormFields();
    
    // Возвращаем функцию для внешнего использования
    return validateOrderFormFields;
}

// Инициализируем валидацию формы заказа
const validateOrderFormFields = validateOrderForm();

// Логика переключения видимости блоков block-spaceBet
function initBlockSpaceBetToggle() {
    const blockSpaceBetElements = document.querySelectorAll('.block-spaceBet');
    
    blockSpaceBetElements.forEach((block, index) => {
        block.addEventListener('click', function() {

            console.log(block);
            console.log(block.parentElement.parentElement);

            let siblings

            if (index == 2) {
                siblings = Array.from(block.parentNode.children).filter(child => {
                        console.log(child)
                        if (child !== block) {
                            return child
                        }
                    }
                );
            } else if (index == 1) {
                // const cityInputBlock = block.parentElement.parentElement.querySelector('.modal__content_new-address__form__input-address');
                // console.log(cityInputBlock);
                // siblings = cityInputBlock ? [cityInputBlock] : [];
                if (CAN_VALID) {
                    const cityInputBlock = block.parentElement.parentElement.querySelector('.modal__content_new-address__form__input-address');
                    console.log(cityInputBlock)
                    siblings = cityInputBlock ? [cityInputBlock] : []
                }
                if (CHOOSE_CITY) {
                    siblings = Array.from(block.parentElement.parentElement.children).filter(child => {
                            console.log(child)
                            if (child !== block.parentNode) {
                                return child
                            }
                        }
                    )
                }
            } else {
                siblings = Array.from(block.parentElement.parentElement.children).filter(child => {
                        console.log(child)
                        if (child !== block.parentNode) {
                            return child
                        }
                    }
                );
            }
            
            const isHidden = siblings.every(sibling => 
                sibling.style.display === 'none'
            );
            
            const svgElement = this.querySelector('svg');
            
            if (isHidden) {
                siblings.forEach(sibling => {
                    sibling.style.display = '';
                });
                console.log('Показаны соседние блоки');
                
                if (svgElement) {
                    svgElement.style.transform = 'rotate(0deg)';
                    svgElement.style.transition = 'transform 0.3s ease';
                }
            } else {
                siblings.forEach(sibling => {
                    sibling.style.display = 'none';
                });
                
                if (svgElement) {
                    svgElement.style.transform = 'rotate(180deg)';
                    svgElement.style.transition = 'transform 0.3s ease';
                }
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initBlockSpaceBetToggle();
    
    const blockSpaceBetElements = document.querySelectorAll('.block-spaceBet');
    blockSpaceBetElements.forEach((block, index) => {
        const svgElement = block.querySelector('svg');
        if (svgElement) {
            svgElement.style.transform = 'rotate(180deg)';
            svgElement.style.transition = 'transform 0.3s ease';
        }
        
        let siblings;
        if (index == 2) {
            siblings = Array.from(block.parentNode.children).filter(child => {
                if (child !== block) {
                    return child;
                }
            });
        } else if (index == 0) {
            siblings = []
        } else {
            siblings = Array.from(block.parentNode.parentNode.children).filter(child => {
                if (child !== block.parentNode) {
                    return child;
                }
            });
        }

        // <div class="address-menu__info-list __address_input__list" data-state="active"><div class="address-menu__info-list__item">Тольятти</div></div>
        
        siblings.forEach(sibling => {
            sibling.style.display = 'none';
        });
    });
});

// Экспортируем функции для глобального использования
window.checkForDeliveryMhand = checkForDeliveryMhand;